import { ModelMetrics, EdaData, SingleFeatureStatDetail, EdaLabelStats } from '../../types';

// Helper to get EDA stats for a specific feature
export const getFeatureStats = (edaData: EdaData | null, featureName: string): SingleFeatureStatDetail | undefined => {
    return edaData?.eda_results?.features_stats?.stats_per_feature?.[featureName];
};

// Helper to get EDA stats for a specific target/label
export const getTargetStats = (edaData: EdaData | null, targetName: string): EdaLabelStats | undefined => {
    return edaData?.eda_results?.labels_stats?.[targetName];
};

// Helper to determine input type
export const getFeatureType = (modelData: ModelMetrics | null, featureName: string): 'numeric' | 'categorical' | 'unknown' => {
    const typeString = modelData?.model_metrics?.model_info?.feature_types?.[featureName]?.toLowerCase();
    if (!typeString) return 'unknown';
    if (typeString.includes('int') || typeString.includes('float') || typeString.includes('number')) {
        return 'numeric';
    }
    if (typeString.includes('object') || typeString.includes('string') || typeString.includes('category') || typeString.includes('bool')) {
        return 'categorical';
    }
    return 'unknown';
}; 